/** 吸附与角度判定的纯函数（便于单元测试，不依赖 DOM）。 */

/** 把任意角度归一化到 [0,360) 的整数（0/90/180/270 等比较）。 */
export function normalizeAngle(deg: number): number {
  return ((Math.round(deg) % 360) + 360) % 360;
}

export interface SnapArgs {
  currentCenterX: number;
  currentCenterY: number;
  correctCenterX: number;
  correctCenterY: number;
  rotation: number;
  threshold: number;
}

/**
 * 是否满足吸附条件：
 *  1. 当前中心与正确中心的距离 ≤ threshold；
 *  2. 旋转已回正（normalizeAngle === 0）。
 */
export function isSnappable(args: SnapArgs): boolean {
  const dx = args.currentCenterX - args.correctCenterX;
  const dy = args.currentCenterY - args.correctCenterY;
  const dist = Math.hypot(dx, dy);
  return dist <= args.threshold && normalizeAngle(args.rotation) === 0;
}

/** 默认吸附阈值：碎片较短边的 30%。 */
export function defaultSnapThreshold(pieceW: number, pieceH: number): number {
  return Math.min(pieceW, pieceH) * 0.3;
}
